import { render, staticRenderFns } from "./MultiStepForm.vue?vue&type=template&id=dc012888&scoped=true&"
import script from "./MultiStepForm.vue?vue&type=script&lang=js&"
export * from "./MultiStepForm.vue?vue&type=script&lang=js&"
import style0 from "./MultiStepForm.vue?vue&type=style&index=0&id=dc012888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc012888",
  null
  
)

export default component.exports